exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.footer{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;-moz-justify-content:space-around;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:100%;min-height:5rem;background-color:#454c55}@media (max-width:599px){.footer{min-height:3rem}}.footer .flexbox{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;-moz-justify-content:space-around;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:100%}@media (min-width:1024px){.footer .flexbox{width:50%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/timeclock/userhub/footer/styles.scss
// module id = 1069
// module chunks = 0